
import React,{useState,useRef,memo,useCallback,useEffect} from 'react'
import {getContentPath} from  'system/AssetManager'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
import Poster from 'assets/img/poster.jpg'
import {ReactComponent as PlayBtn} from 'assets/icons/deck-play-btn.svg'
import classNames from 'classnames'

function VideoComponent(props){
    
    
    const [inline,setInline] = useState({})
    const [vidSrc,setVidSrc] = useState(null)
    // Render path only. Non-empty means "screenshot this still instead of the video".
    const [posterSrc,setPosterSrc] = useState(null)
    const [canPlay, setCanPlay] = useState(false);
    
    // The PDF renderer needs a DECODED frame, not just metadata (see the <video> comment
    // below). Named once here so the two nearly-identical elements cannot drift apart.
    const isRenderOnly = props.renderOnly === true
    const renderPreload = isRenderOnly ? 'auto' : 'metadata'

    // A ref, not a plain local. `let bLoaded = false` was re-initialised on EVERY render,
    // so it never actually deduped: a re-render between two media events reset it and the
    // component reported itself loaded to Page.js a second time. Page counted those
    // reports, so a double report satisfied its component count early and the page
    // declared itself ready with other components still outstanding.
    const refLoaded = useRef(false)
    const refEle = useRef()
    const refVid = useRef()
    const refPoster = useRef()
    const reloadCount = useRef();
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})
    // eslint-disable-next-line no-unused-vars
    const [isAutoplay, setIsAutoplay] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const [vidStyle,setVidStyle] = useState({width:"100%",height:"100%",objectFit:props.fit?props.fit:'cover'})
    const refLastLoadComplete = useRef(0);
    const refLastAnimComplete = useRef(0);


    useEffect(()=>{ 
        refOrigOffset.current=refEle.current.offsetLeft
        if(refFormat.current && refFormat.current.animation){
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
            // console.log('refFormat.current', refFormat.current)
            // refVid is null on the render path when a poster replaced the <video>.
            if (refFormat.current.loop && refVid.current) {
                refVid.current.loop = true
            } 
    
        }
        
    },[inline]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        // console.log(refAnimationModel.current)
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])// eslint-disable-line react-hooks/exhaustive-deps

    const onIntersect = useCallback((evt,threshold)=>{
        // console.log('VID onIntersect', refFormat.current, threshold)
        if (refFormat.current.loop && refVid.current) {
            refVid.current.loop = true
        } 

        // console.log('onINTERSECT video', evt.detail.isIntersecting, refFormat.current)

        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
                animateIntersect(refEle.current,refAnimationModel.current)  
            if(evt.detail.intersectionRatio >=0.5)
                if (refFormat.current.autoplay) {
                    // refVid.current.play()
                    console.log('play')
                }
              
            
        }
        else if(evt.detail.intersectionRatio <=0.001) {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
            if (refVid.current && refVid.current.currentTime > 0) {
                refVid.current.pause()
                refVid.current.currentTime = 0;
            }
            
            }
        else if(evt.detail.intersectionRatio <=0)
            if (refVid.current && refVid.current.currentTime > 0) {
                refVid.current.pause()
                refVid.current.currentTime = 0;
            }
            console.log('pause')
    


    },[refEle, refVid])


    const onAnim = useCallback((evt,threshold)=>{
            const currentTime = Date.now();
            const timeSinceLastCall = currentTime - refLastAnimComplete.current;
            
            // Prevent execution if called within 1 second (1000ms)
            if (timeSinceLastCall < 1000) {
                console.log('onAnim VIDEO throttled - called too soon', {
                    index: props.index,
                    videoId: refVid.current?.id,
                    timeSinceLastCall,
                    remaining: 1000 - timeSinceLastCall
                });
                return;
            }
            
            // Update the last execution time
            refLastAnimComplete.current = currentTime;
            
            console.log('VID onAnim', evt, threshold, refFormat.current)
            

            if (refFormat.current.loop && refVid.current) {
                refVid.current.loop = true
            }            
            if(evt)
            {
                animateIntersect(refEle.current,refAnimationModel.current)  
              
                if (refFormat.current.autoplay && refVid.current) {
            
                    try {
                        if (refVid.current.paused) {
                            refVid.current.currentTime = 0;
                            refVid.current.play();
                            console.log('vid play', refVid.current.id)
                        }
                        
                    } catch (error) {
                        console.error('vid play error', error)
                    }
                   
                }
            }
            else {
                setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
                if (refVid.current) {
                    refVid.current.pause()
                    refVid.current.currentTime = 0;
                    console.log('vid paused', refVid.current.id)
                }
            }
                
        },[refEle, refVid])

    useEffect(()=>{
        // console.log(props.model,props.format)
        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)
        
        let style ={position:'absolute',transform: 'translateZ(0), perspective: 1000px',willChange:'transform'}

        if (refFormat.current && refVid) {
            if(refFormat.current.style){ style = Object.assign(style,refFormat.current.style) }
        
            let f = refFormat.current.file?refFormat.current.file:refFormat.current.image
            setVidSrc(getContentPath(f))

            /* On the render path, prefer a still of the first frame over the video itself.

               A screenshot can only capture what the browser has decoded and painted, and
               that is not something the renderer can count on: the render container is
               CPU-capped, and a wall-resolution stream can sit at readyState 1 -- metadata
               known, no frame ever produced -- in which case NO event fires and the page
               screenshots white (#1853). The still removes video decode from the render
               entirely, and a frozen frame is what belongs in a PDF anyway.

               Falls back to the <video> when there is no poster, which is exactly today's
               behaviour, so an ungenerated poster degrades to the old race and never to a
               blank layer. Presenting never takes this path. */
            if(isRenderOnly && refFormat.current.video_poster){
                setPosterSrc(getContentPath(refFormat.current.video_poster))
            }
            // console.log("seting ",getContentPath(f))

            console.log('refFormat', refFormat.current, props.model.formats)

            // console.log("FORMAT", refFormat.current, props.model.formats, props.format, f)

            //set up animation Type
            if(refFormat.current.animation ){
                console.log('VIDEO animation config:', refFormat.current.animation, 'index:', props.index)
                if(refFormat.current.animation.typeName==='parallax'){
                    props.setScrollCallback(onScroll,props.index)
                    style.willChange='transform'
                } 
                else if(refFormat.current.animation.typeName==='page'){
                    console.log('Registering onAnim for VIDEO index:', props.index)
                    props.onIntersect(onIntersect,props.index)
                    props.onAnim(onAnim, props.index)
                    style.willChange='transform, scale, opacity'
                }
            } else {
                console.log('VIDEO has NO animation config, index:', props.index)
            }

            
            
            

            
        }
        // console.log('style', props.model.formats, Globals.instance().getCanvasFormat(props.model.formats,props.format))
        setInline(style)

        return ()=>{
            //cleanup
        
        }
        
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])




    useEffect(() => {
        if (vidSrc) {
            if (refVid.current) {
                refVid.current.load();
                // refVid.current.currentTime = 0;
              }
        }
    }, [vidSrc])

    useEffect(() => {
        if (canPlay){
            if (refFormat.current.autoplay) {
                try {
                    if (refVid.current.paused) {
                        refVid.current.play();
                    }
                    
                } catch (error) {
                    console.error('vid play error', error)
                }
                
            
            }
        }
    }, [canPlay])

    // `loadeddata` means a frame has been DECODED. It does not mean one has been PRESENTED
    // to the compositor, and a screenshot only ever sees what the compositor has produced.
    // requestVideoFrameCallback fires exactly when a frame has been presented for display,
    // which is the video counterpart of img.decode() and the strongest signal available.
    //
    // Render path only, and purely additive: loadeddata and canplay still report, so a
    // browser without rVFC, or a video that never presents a frame, is no worse off than
    // before -- onLoad is idempotent, so whichever signal arrives first wins.
    useEffect(() => {
        if (!isRenderOnly || !vidSrc) return undefined
        const vid = refVid.current
        if (!vid || typeof vid.requestVideoFrameCallback !== 'function') return undefined
        const handle = vid.requestVideoFrameCallback(() => { onLoad() })
        return () => { try { vid.cancelVideoFrameCallback(handle) } catch(e) { /* already fired */ } }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRenderOnly, vidSrc])

    // Bounded fallback, render path only. A video that never decodes -- bad codec, dead S3
    // object -- would otherwise hold the page short of its component count until the API's
    // 45s render-ready timeout expires, and that is 45s PER PAGE on a 161-page narrative.
    // Reporting loaded here caps it and lets the rest of the page through; the resulting
    // screenshot is no worse than the one today's fixed sleep would have taken.
    useEffect(() => {
        if (!isRenderOnly || !vidSrc) return undefined
        const t = setTimeout(() => {
            if (!refLoaded.current) {
                console.warn('VIDEO render fallback: never decoded a frame', vidSrc)
                onLoad()
            }
        }, 10000)
        return () => clearTimeout(t)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRenderOnly, vidSrc])


    function onError(evt){
        console.error("video load error"+refLoaded.current, evt.target.src)
        // onErrorLoad(evt)
        console.log("src "+evt.target.src)
        if(!refLoaded.current && vidSrc!==""){
            Globals.instance().trackError('Video '+vidSrc+' ',false)
            onLoad() //dont hold up the page 
        }
    }
    
    /* Same guarantee PNG makes: the <img> load event means the bytes arrived, not that
       the pixels exist. These stills are full-size (12000px wide for a wall video), so the
       decode is exactly the expensive part -- reporting on load alone would reintroduce the
       blank-layer race in a different place. decode() resolves only when it is paintable;
       a failure still reports, so a bad poster cannot hang the page. */
    function onPosterLoad(){
        const img = refPoster.current
        if(!img || typeof img.decode !== 'function'){ onLoad(); return }
        img.decode().then(onLoad).catch((e)=>{
            console.warn('VIDEO render: poster decode failed, reporting loaded anyway', e && e.name)
            onLoad()
        })
    }

    function onLoad(){
      
        const currentTime = Date.now();
        const timeSinceLastCall = currentTime - refLastLoadComplete.current;
        
        // Prevent execution if called within 1 second (1000ms)
        if (timeSinceLastCall < 1000) {
            console.log('onLoad VIDEO throttled - called too soon', {
                index: props.index,
                videoId: refEle.current?.id,
                timeSinceLastCall,
                remaining: 1000 - timeSinceLastCall
            });
            return;
        }
        
        // Update the last execution time
        refLastLoadComplete.current = currentTime;

        console.log('onLoad VIDEO', props.index, refEle.current.id)

        // Ensure video starts at beginning
        if (refVid.current) {
            refVid.current.currentTime = 0;
        }
        
        //down res the image
        if(!refLoaded.current){
            setCanPlay(true);
            props.onLoad(props.index,refEle.current,props.model)
            
            refLoaded.current = true

            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }

         

        }
        
    }    


    function onClickVideo(e) {
        props.onClickElem('video', e.target, null)
        if (refVid.current) {
            if (refVid.current.paused) {
        
                setIsPlaying(false);
            } else {
          
                setIsPlaying(true);
            }
        }
        
    }
    
    const handleRetry = (e) => {

        if (refVid.current) {
          // Reload the video
          if (reloadCount.current <2) {
            refVid.current.load();
            reloadCount.current+=1
            onLoad()
            if (refFormat.current.autoplay) {
            
                try {
                    if (refVid.current.paused) {
                        // refVid.current.play();
                    }
                    
                } catch (error) {
                    console.error('vid play error', error)
                }
            
            }
            console.log('reloading video')
          } else {
            console.error('video loading error', e)
          }
       
        }
      };
    
    return ( 
        <div style={inline} ref={refEle} id={refFormat.current && "component_dim_file_" + refFormat.current.component} data-opacity={inline.opacity} data-fileformat={refFormat.current && refFormat.current.file}>

        <span className={classNames("play-btn", !isPlaying && "paused")}>
            <PlayBtn  />
        </span>

        {(refFormat.current && posterSrc) ?

           /* PDF render path with a poster available: a plain <img>, no video element at
              all. Reported through the same decode() gate PNG uses, so the page cannot
              call itself ready until this frame is genuinely paintable. */
           (<img src={posterSrc} style={vidStyle} alt="" ref={refPoster}
                 id={'video-poster-' + refFormat.current.id}
                 onLoad={onPosterLoad} onError={onLoad} />)

        : (refFormat.current && vidSrc) ?

           /* Readiness means two different things here, so the signal differs by mode.

              PRESENTING (preload="metadata"): the browser fetches only the header and never
              buffers enough frames to satisfy canplay, so onCanPlay frequently never fires
              and the video would never report itself loaded -- one video could hold a page
              permanently short of its component count. onLoadedMetadata is the signal, and
              that is correct here: a presentation must not stall waiting for frames.

              RENDERING for the PDF: metadata is exactly the wrong signal. `loadedmetadata`
              means duration and dimensions are known and NOTHING has been decoded, so the
              element has no frame to paint -- which is why a video background screenshotted
              white on staging (#1853) the moment the API started waiting on `render-ready`
              instead of sleeping 7s. `loadeddata` is the event that means "the frame at the
              current position is decoded", and preload="auto" is what lets it arrive.

              onCanPlay stays on both paths as a second chance; onLoad is idempotent
              (refLoaded guard + 1s throttle), so whichever fires first wins. */
           (refFormat.current.autoplay ? <video data-auto="true" preload={renderPreload} style={vidStyle} onClick={(e) => onClickVideo(e)} ref={refVid} muted playsInline src={vidSrc} type="video/mp4" id={'video-' + refFormat.current.id} onLoadedMetadata={isRenderOnly ? undefined : onLoad} onLoadedData={isRenderOnly ? onLoad : undefined} onCanPlay={onLoad} onError={handleRetry}>
                <source src={vidSrc} type="video/mp4"></source>
            </video> : <video preload={renderPreload} style={vidStyle} id={'video-' + refFormat.current.id} onClick={(e) => onClickVideo(e)} ref={refVid} playsInline src={vidSrc} type="video/mp4" onLoadedMetadata={isRenderOnly ? undefined : onLoad} onLoadedData={isRenderOnly ? onLoad : undefined} onCanPlay={onLoad} onError={handleRetry}>
            <source src={vidSrc} type="video/mp4"></source>
        </video>)
        
             : <span />}

             {!canPlay && <div className={`poster-overlay`}></div>}
        </div>
        
    )

}

const VIDEO = memo( VideoComponent ,(prev,next)=>{ 
    return prev.imgSrc === next.imgSrc
})

export  {VIDEO}
